export const isFieldInvalid = (
  validationResult: string[] | undefined
): boolean => {
  return !!validationResult?.length
}
